"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FORM_SEGMENT = exports.REGISTRATION_MEMBER_ROUTE = exports.EDIT_DRAFT_ROUTE = exports.EDIT_ROUTE = exports.EDIT_WORK_ROUTE = exports.RIGHTSHOLDER_SUB_ROUTES = exports.BULK_ROUTES = exports.FORM_ROUTE = exports.STEP_ROUTES = exports.WIZARD_ROUTE = exports.MANUAL_ROUTE = exports.CREATE_WORK_ROUTE = exports.RIGHTSHOLDER_ROUTE_WITH_ID = exports.CHANGE_PASSWORD_ROUTE = exports.PROFILE_ROUTE = exports.RECORDING_DETAILS_ROUTE_WITH_RECORDING_ID = exports.UI_ROUTE = exports.ACCESS_DENIED_ROUTE = exports.CONTACT_US_ROUTE = exports.PUBLIC_VIEW_WORK_ROUTE_WITH_WORK_ID = exports.SEARCH_ROUTE_WITH_TAB_NAME = exports.SEARCH_ROUTE = exports.NEW_USER_ROUTE = exports.CREATE_PASSWORD_ROUTE_WITH_ACT_CODE = exports.FORGOT_PASSWORD_ROUTE = exports.SIGN_UP_COMPLETE_ROUTE = exports.SIGN_UP_ROUTE = exports.INACTIVE_ROUTE = exports.UPCOMING_NOTES_ROUTE = exports.RELEASE_NOTES_ROUTE = exports.LOGIN_ROUTE = exports.SONGWRITER_ROUTE = exports.RIGHTSHOLDER_ROUTE = exports.RECORDING_DETAILS_ROUTE = exports.CREATE_PASSWORD_ROUTE = exports.MATCH_HISTORY_ROUTE = exports.DRAFTS_ROUTE = exports.HISTORY_ROUTE = exports.CATALOG_ROUTE = exports.RH_USER_PERMISSION_ROUTE = exports.RH_CONTACT_ROUTE = exports.RH_MAINTENANCE_ROUTE = exports.RECORDING_ROUTE = exports.VIEW_DRAFT_ROUTE = exports.VIEW_ROUTE = exports.VIEW_TRANSACTION_ROUTE = exports.VIEW_SUBMISSION_ROUTE = exports.VIEW_WORK_ROUTE = exports.OVERCLAIM_VIEW_ROUTE_WITH_OC_HEADER_ID = exports.OVERCLAIM_ROUTE = void 0;
exports.NOTIFICATION_PREFERENCES_ROUTE = exports.REGISTRATION_SONGWRITER_ROUTE = exports.SONGWRITER_SUB_ROUTES = exports.SONGWRITER_ROUTE_WITH_ID = exports.ENROLL_MFA_ROUTE = exports.QUESTIONNAIRE_ROUTE = void 0;
const param_1 = require("@App/navigation/param");
const RELEASE_NOTES_ROUTE = 'release-notes';
exports.RELEASE_NOTES_ROUTE = RELEASE_NOTES_ROUTE;
const UPCOMING_NOTES_ROUTE = 'upcoming-notes';
exports.UPCOMING_NOTES_ROUTE = UPCOMING_NOTES_ROUTE;
exports.OVERCLAIM_ROUTE = 'overclaim';
exports.OVERCLAIM_VIEW_ROUTE_WITH_OC_HEADER_ID = `${exports.OVERCLAIM_ROUTE}/${param_1.PARAM.overclaimHeaderId}`;
const LOGIN_ROUTE = 'login';
exports.LOGIN_ROUTE = LOGIN_ROUTE;
const NOTIFICATION_PREFERENCES_ROUTE = 'notification/preferences';
exports.NOTIFICATION_PREFERENCES_ROUTE = NOTIFICATION_PREFERENCES_ROUTE;
exports.VIEW_WORK_ROUTE = 'catalog/work';
exports.VIEW_SUBMISSION_ROUTE = 'registration-history/submission';
exports.VIEW_TRANSACTION_ROUTE = 'registration-history/transaction';
const PUBLIC_VIEW_WORK_ROUTE_WITH_WORK_ID = `catalog/work/${param_1.PARAM.workId}`;
exports.PUBLIC_VIEW_WORK_ROUTE_WITH_WORK_ID = PUBLIC_VIEW_WORK_ROUTE_WITH_WORK_ID;
const CONTACT_US_ROUTE = 'contact-us';
exports.CONTACT_US_ROUTE = CONTACT_US_ROUTE;
exports.VIEW_ROUTE = 'view';
exports.VIEW_DRAFT_ROUTE = 'registration-drafts/draft';
exports.RECORDING_ROUTE = 'recording';
exports.RH_MAINTENANCE_ROUTE = 'maintenance';
exports.RH_CONTACT_ROUTE = `${exports.RH_MAINTENANCE_ROUTE}/contact`;
exports.RH_USER_PERMISSION_ROUTE = `${exports.RH_MAINTENANCE_ROUTE}/user-permissions`;
exports.CATALOG_ROUTE = 'catalog';
exports.HISTORY_ROUTE = 'registration-history';
exports.DRAFTS_ROUTE = 'registration-drafts';
exports.MATCH_HISTORY_ROUTE = 'match-history';
const INACTIVE_ROUTE = 'handle-inactive';
exports.INACTIVE_ROUTE = INACTIVE_ROUTE;
const SIGN_UP_ROUTE = 'sign-up';
exports.SIGN_UP_ROUTE = SIGN_UP_ROUTE;
const SIGN_UP_COMPLETE_ROUTE = 'sign-up-complete';
exports.SIGN_UP_COMPLETE_ROUTE = SIGN_UP_COMPLETE_ROUTE;
const FORGOT_PASSWORD_ROUTE = 'forgot-password';
exports.FORGOT_PASSWORD_ROUTE = FORGOT_PASSWORD_ROUTE;
exports.CREATE_PASSWORD_ROUTE = 'create-password';
const NEW_USER_ROUTE = 'new-user';
exports.NEW_USER_ROUTE = NEW_USER_ROUTE;
const CREATE_PASSWORD_ROUTE_WITH_ACT_CODE = `${exports.CREATE_PASSWORD_ROUTE}/${param_1.PARAM.activatingCode}`;
exports.CREATE_PASSWORD_ROUTE_WITH_ACT_CODE = CREATE_PASSWORD_ROUTE_WITH_ACT_CODE;
const SEARCH_ROUTE = 'search';
exports.SEARCH_ROUTE = SEARCH_ROUTE;
const SEARCH_ROUTE_WITH_TAB_NAME = `${SEARCH_ROUTE}/${param_1.PARAM.tabName}`;
exports.SEARCH_ROUTE_WITH_TAB_NAME = SEARCH_ROUTE_WITH_TAB_NAME;
const ACCESS_DENIED_ROUTE = 'access-denied';
exports.ACCESS_DENIED_ROUTE = ACCESS_DENIED_ROUTE;
const UI_ROUTE = 'ui';
exports.UI_ROUTE = UI_ROUTE;
const ENROLL_MFA_ROUTE = 'enroll-mfa';
exports.ENROLL_MFA_ROUTE = ENROLL_MFA_ROUTE;
exports.RECORDING_DETAILS_ROUTE = 'recording-details';
const RECORDING_DETAILS_ROUTE_WITH_RECORDING_ID = `${exports.RECORDING_DETAILS_ROUTE}/${param_1.PARAM.recordingId}`;
exports.RECORDING_DETAILS_ROUTE_WITH_RECORDING_ID = RECORDING_DETAILS_ROUTE_WITH_RECORDING_ID;
const PROFILE_ROUTE = 'profile';
exports.PROFILE_ROUTE = PROFILE_ROUTE;
const CHANGE_PASSWORD_ROUTE = `${PROFILE_ROUTE}/change-password`;
exports.CHANGE_PASSWORD_ROUTE = CHANGE_PASSWORD_ROUTE;
// register rightsholder routes
const REGISTRATION_MEMBER_ROUTE = 'registration-member';
exports.REGISTRATION_MEMBER_ROUTE = REGISTRATION_MEMBER_ROUTE;
const FORM_SEGMENT = 'form';
exports.FORM_SEGMENT = FORM_SEGMENT;
const QUESTIONNAIRE_ROUTE = 'questionnaire';
exports.QUESTIONNAIRE_ROUTE = QUESTIONNAIRE_ROUTE;
// register songwriter routes
const REGISTRATION_SONGWRITER_ROUTE = 'registration-songwriter';
exports.REGISTRATION_SONGWRITER_ROUTE = REGISTRATION_SONGWRITER_ROUTE;
exports.RIGHTSHOLDER_ROUTE = 'member';
const RIGHTSHOLDER_ROUTE_WITH_ID = `${exports.RIGHTSHOLDER_ROUTE}/${param_1.PARAM.rightsholderId}`;
exports.RIGHTSHOLDER_ROUTE_WITH_ID = RIGHTSHOLDER_ROUTE_WITH_ID;
const RIGHTSHOLDER_SUB_ROUTES = Object.freeze({
    summary: 'summary',
    dashboard: 'dashboard',
    catalog: {
        viewWork: `${exports.VIEW_WORK_ROUTE}/${param_1.PARAM.workId}/${exports.VIEW_ROUTE}`,
        root: exports.CATALOG_ROUTE,
    },
    registrationHistory: {
        root: `${exports.HISTORY_ROUTE}`,
        submission: `${exports.VIEW_SUBMISSION_ROUTE}/${param_1.PARAM.workId}/${exports.VIEW_ROUTE}`,
        transaction: `${exports.VIEW_TRANSACTION_ROUTE}/${param_1.PARAM.workId}/${exports.VIEW_ROUTE}`,
    },
    drafts: {
        root: `${exports.DRAFTS_ROUTE}`,
        viewDraft: `${exports.VIEW_DRAFT_ROUTE}/${param_1.PARAM.workId}/${exports.VIEW_ROUTE}`,
    },
    claimingTool: 'claiming-tool',
    matchingTool: 'matching-tool',
    matchHistory: {
        recording: `${exports.MATCH_HISTORY_ROUTE}/${param_1.PARAM.submissionId}/${exports.RECORDING_ROUTE}/${param_1.PARAM.recordingGroupCategory}`,
        submission: `${exports.MATCH_HISTORY_ROUTE}/${param_1.PARAM.submissionId}`,
        root: exports.MATCH_HISTORY_ROUTE,
    },
    overclaim: {
        root: exports.OVERCLAIM_ROUTE,
        view: exports.OVERCLAIM_VIEW_ROUTE_WITH_OC_HEADER_ID,
    },
    royalties: {
        statements: 'royalties/statements',
        annualStatements: 'royalties/annual-statements',
        rateSheets: 'royalties/rate-sheets',
        root: 'royalties',
    },
    maintenance: {
        rightsholderContact: `${exports.RH_CONTACT_ROUTE}/${param_1.PARAM.contactId}`,
        rightsholderContacts: `${exports.RH_MAINTENANCE_ROUTE}/contacts`,
        userPermission: `${exports.RH_USER_PERMISSION_ROUTE}/${param_1.PARAM.userId}`,
        userPermissions: exports.RH_USER_PERMISSION_ROUTE,
        root: exports.RH_MAINTENANCE_ROUTE,
    },
});
exports.RIGHTSHOLDER_SUB_ROUTES = RIGHTSHOLDER_SUB_ROUTES;
// work routes
const CREATE_WORK_ROUTE = 'create-work';
exports.CREATE_WORK_ROUTE = CREATE_WORK_ROUTE;
const MANUAL_ROUTE = 'manual';
exports.MANUAL_ROUTE = MANUAL_ROUTE;
const WIZARD_ROUTE = `${MANUAL_ROUTE}/wizard`;
exports.WIZARD_ROUTE = WIZARD_ROUTE;
const FORM_ROUTE = `${MANUAL_ROUTE}/form`;
exports.FORM_ROUTE = FORM_ROUTE;
const BULK_ROUTES = Object.freeze({
    root: 'bulk',
    fileUpload: 'file-upload',
    fileReview: 'file-review',
    submission: 'submission',
});
exports.BULK_ROUTES = BULK_ROUTES;
const EDIT_ROUTE = 'edit';
exports.EDIT_ROUTE = EDIT_ROUTE;
const EDIT_WORK_ROUTE = `${exports.CATALOG_ROUTE}/${param_1.PARAM.typeWork}/${param_1.PARAM.workId}/${EDIT_ROUTE}`;
exports.EDIT_WORK_ROUTE = EDIT_WORK_ROUTE;
const EDIT_DRAFT_ROUTE = `${exports.DRAFTS_ROUTE}/${param_1.PARAM.typeWork}/${param_1.PARAM.workId}/${EDIT_ROUTE}`;
exports.EDIT_DRAFT_ROUTE = EDIT_DRAFT_ROUTE;
// work step routes
const STEP_ROUTES = Object.freeze({
    workDetails: 'work-details',
    writers: 'writers',
    writersShares: 'writers-shares-role',
    publishers: 'publishers',
    publishersShares: 'publishers-shares',
    publishersWriters: 'publishers-writers',
    recordings: 'recordings',
    review: 'review',
    submission: 'submission',
});
exports.STEP_ROUTES = STEP_ROUTES;
// songwriter routes
exports.SONGWRITER_ROUTE = 'songwriter';
const SONGWRITER_ROUTE_WITH_ID = `${exports.SONGWRITER_ROUTE}/${param_1.PARAM.songwriterId}`;
exports.SONGWRITER_ROUTE_WITH_ID = SONGWRITER_ROUTE_WITH_ID;
const SONGWRITER_SUB_ROUTES = Object.freeze({
    link: 'link',
    catalog: {
        viewWork: `${exports.VIEW_WORK_ROUTE}/${param_1.PARAM.workId}/${exports.VIEW_ROUTE}`,
        root: exports.CATALOG_ROUTE,
    },
    myWriters: 'my-writers',
    searchedWork: `search/work/${param_1.PARAM.workId}/${exports.VIEW_ROUTE}`,
});
exports.SONGWRITER_SUB_ROUTES = SONGWRITER_SUB_ROUTES;
